import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';

const TISAxios: AxiosInstance = axios.create();

function normalizeErrorDetail(detail: any) {
    // detail 이 없을 때 detail.toString() 크래시 방지
    if (detail === null || detail === undefined) {
        return 'Internal Error';
    }
    if (typeof(detail) === 'object') {
        const message = detail.error || detail.message || JSON.stringify(detail);
        return {
            ...detail,
            toString: () => message,
        };
    }

    return detail.toString();
}

TISAxios.interceptors.request.use(
    async config => {
        const accessToken: string | null = window.sessionStorage.getItem('accessToken');
        // 기존 헤더(Content-Type 등)를 보존하고 Authorization 만 주입 (헤더 통째 덮어쓰기 방지)
        config.headers = {
            ...config.headers,
            'Authorization': `Bearer ${accessToken}`,
        }
        return config
    },
    error => {
        return Promise.reject(error);
    }
)

TISAxios.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        // 네트워크 오류 등 응답 자체가 없는 경우 가드 (백엔드 다운 시 인터셉터 크래시 방지)
        if (!error.response) {
            return Promise.reject('서버에 연결할 수 없습니다.');
        }

        const status = error.response.status;

        if (status === 401) {
            const originalRequest: AxiosRequestConfig & { _retry?: boolean } = error.config;

            // 이미 한 번 재발급/재시도했는데도 401 → 무한루프 방지, 세션 만료 처리
            if (originalRequest._retry) {
                window.sessionStorage.clear();
                window.location.reload();
                return Promise.reject('로그인 시간이 만료되었습니다. 재 로그인 해주세요.');
            }
            originalRequest._retry = true;

            try {
                // 토큰 재발급 (인터셉터 재귀 방지를 위해 순수 axios 사용)
                const reissue = await axios.post(`/tis/security/reissue`, {
                    'accessToken': window.sessionStorage.getItem('accessToken'),
                    'refreshToken': window.sessionStorage.getItem('refreshToken')
                });

                if (reissue.data) {
                    // 새 토큰 저장
                    window.sessionStorage.setItem('accessToken', reissue.data.accessToken);
                    window.sessionStorage.setItem('refreshToken', reissue.data.refreshToken);
                    window.sessionStorage.setItem('authorization', reissue.data.authorization);
                    window.sessionStorage.setItem('group', reissue.data.user_group);
                    // 원 요청을 새 토큰으로 재시도하고 그 결과를 그대로 반환 (기존 죽은 코드/리로드 제거)
                    return TISAxios(originalRequest);
                }
                return Promise.reject('로그인 정보를 갱신하지 못했습니다.');
            } catch (reissueError: any) {
                // 재발급 실패(만료 등) → 세션 정리 후 로그인 화면으로
                window.sessionStorage.clear();
                window.location.reload();
                return Promise.reject('로그인 시간이 만료되었습니다. 재 로그인 해주세요.');
            }
        } else if (status === 403) {
            window.sessionStorage.clear();
            window.location.reload();
            return Promise.reject('로그인 시간이 만료되었습니다. 재 로그인 해주세요.');
        } else if (status === 400) {
            return Promise.reject(normalizeErrorDetail(error.response.data?.detail));
        } else {
            return Promise.reject('Internal Error');
        }
    })

export default TISAxios;
